import { Helmet } from "react-helmet-async";
import { isCheckRS } from "../utils/validations";

export default function HelmetContents({
  title,
  canonicalUrl,
  description,
  imageUrl,
  imageAlt,
  // keywords,
  type = "SunFlower Tours HG",
  DynamicMetas = [],
}) {
  return (
    <>
      <Helmet>
        <title>{isCheckRS(title)}</title>
        <meta name="description" content={isCheckRS(description)} />
        <link rel="canonical" href={`${window.location.origin}${canonicalUrl ? canonicalUrl : ""}`} />
        <meta property="og:title" content={isCheckRS(title)} />
        <meta property="og:description" content={isCheckRS(description)} />

        {/* <meta name="keywords" content={isCheckRS(keywords)} /> */}
        <meta property="og:image:alt" content={imageAlt} />
        <meta
          property="og:url"
          content={`${window.location.origin}${
            canonicalUrl ? canonicalUrl : ""
          }`}
        />
        <meta name="og:site_name" content="Sunflower Ha Giang Tours" />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:image:url" content={imageUrl} />
        <meta property="og:image:alt" content={imageAlt} />
        <meta property="og:type" content={type} />

        {DynamicMetas.length > 0 &&
          DynamicMetas.map((v, index) => <meta key={index} {...v} />)}
      </Helmet>
    </>
  );
}
